import { Suspense, lazy } from 'react'

import Spinner from 'src/components/common/spinner'

import ErrorBoundary from './errorboundary'

const SettingsView = lazy(() => import('./view'))

const SettingsViewContainer = () => {
    return (
        <Suspense fallback={<Spinner />}>
            <ErrorBoundary>
                <SettingsView />
            </ErrorBoundary>
        </Suspense>
    )
}

export default SettingsViewContainer
